import React from "react";
import AboutSection from "../Components/AboutSection";
import AdmissionProcess from "../Components/AdmissionProcess";
import AlumniTestimonial from "../Components/AlumniTestimonial";
import BlogSection from "../Components/BlogSection";
import CallAction from "../Components/CallAction";
import Faq from "../Components/Faq";
import FreeRegistration from "../Components/FreeRegistration";
import Funfact from "../Components/Funfact";
import Hero from "../Components/Hero";
import MediumEducation from "../Components/MediumEducation";
import SchoolEnvironment from "../Components/SchoolEnvironment";
import TeachersMessage from "../Components/TeachersMessage";
import WhyChoose from "../Components/WhyChoose";

const Home = ({ schoolInfo }) => {
  return (
    <>
      <Hero schoolInfo={schoolInfo} />
      <AboutSection />
      <SchoolEnvironment />
      <WhyChoose />
      <MediumEducation />
      <FreeRegistration />
      <TeachersMessage />
      <Funfact />
      <AdmissionProcess />
      <AlumniTestimonial />
      <BlogSection />
      <Faq />
      <CallAction />
    </>
  );
};

export default Home;
